export default (
  state = {
    isFetchingCourses: false,
    isFetchingDefaultCourse: false,
    courseCode: null,
    data: null,
  },
  action,
) => {
  switch (action.type) {
    case 'REQUEST_DEFAULT_COURSE':
      return {
        ...state,
        isFetchingDefaultCourse: true,
      }
    case 'STORE_COURSE_CODE':
      return {
        ...state,
        isFetchingDefaultCourse: false,
        courseCode: action.courseCode,
      }
    case 'REQUEST_COURSES':
      return {
        ...state,
        isFetchingCourses: true,
      }
    case 'RECEIVE_COURSES':
      return {
        ...state,
        isFetchingCourses: false,
        data: action.courses.reduce((accumulator, currentCourse) => {
          return {
            ...accumulator,
            [currentCourse.courseCode]: currentCourse,
          }
        }, {})
      }
    default:
      return state
  }
}
